import { createNinjaToaster } from "./create.mjs";
import { defineNuxtPlugin } from "#imports";
export default defineNuxtPlugin(() => {
  return {
    provide: {
      nt: createNinjaToaster()
    }
  };
});
